import { render, staticRenderFns } from "./vidvie-brand.vue?vue&type=template&id=5afa2d13"
import script from "./vidvie-brand.vue?vue&type=script&lang=js"
export * from "./vidvie-brand.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports